import { atom } from 'recoil';
import { ModalV2Type } from '../types/modalV2';

export const modalV2Atom = atom<ModalV2Type>({
  key: 'modalV2Atom',
  default: {
    isOpen: false,
    inputs: null
  }
});
